import {
    INIT_BOOKMARKS,
    ADD_BOOKMARK,
    REMOVE_BOOKMARK,
} from 'redux/bookmarks/actions'
import { remove } from 'lodash'
import { bookmarksMatching } from 'helpers/bookmark'

const initialState = []

export const bookmarks = (state = initialState, action) => {

    switch (action.type)
    {
        case INIT_BOOKMARKS:
            return [
                ...state,
                ...action.bookmarks,
            ]

        case ADD_BOOKMARK:
            return [
                ...state,
                {
                    uuid: action.media.uuid,
                    arkId: action.media.record.arkId,
                }
            ]

        case REMOVE_BOOKMARK:
            const newState = [ ...state ]

            const bookmarkToBeRemoved = {
                uuid: action.media.uuid,
                arkId: action.media.record.arkId,
            }

            remove(newState, function(bookmark) {
                return bookmarksMatching(bookmarkToBeRemoved, bookmark)
            })

            return newState

        default:
            return state
    }
}
